export default {"src":"/_next/static/media/user_filled.3a97e736.svg","height":24,"width":24};